import React from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from "react-router-dom";

import Navbar from '../components/navbar';
import Footer from '../components/footer';
import '../styles/servicesPage.css';
import useScrollAnimation from '../hooks/useScrollAnimation';

function ServicesPage() {
  useScrollAnimation();

  const navigate = useNavigate();

  const serviceRoutes = {
    "Senior Discount": "/book-appointment",
    "Open 7 Days": "/book-appointment",
    "Prescribing Pharmacist on Duty": "/book-appointment",
    "Injection & Vaccination": "/book-appointment",
    "Travel Consultation": "/book-appointment",
    "Free Prescription Delivery": "/services/delivery",
    "Blister Packaging": "/services/blister-packaging",
    "Strep & Lab Testing": "/services/strep-lab-testing",
    "Medication Review": "/book-appointment",
    "Smoking Cessation": "/book-appointment",
    "Specialty Compounding": "/book-appointment",
    "Blood Pressure Monitoring": "/book-appointment",
    "Diabetes Management": "/book-appointment"
  };
  
  return (
    <>
      <Navbar />

      <section className="services-page">
        <div className="services-hero fade-in">
          <h1>Our Services</h1>
          <p>Healthcare that enhances your life and style – available 7 days a week.</p>
        </div>

        <div className="services-content">
          {/* {[
            ["fa-percent", "Senior Discount", "20% Senior Discount everyday to help reduce healthcare costs."],
            ["fa-calendar-alt", "Open 7 Days", "Pharmacy and Travel Clinic."],
            ["fa-user-nurse", "Prescribing Pharmacist on Duty", "Prescribing pharmacist available all the time for expert guidance."],
            ["fa-syringe", "Injection & Vaccination", "Professional injection services and up-to-date vaccinations.", true],
            ["fa-plane", "Travel Consultation", "Before and after your trip.", true],
            ["fa-truck", "Free Prescription Delivery", "Fast, convenient medication delivery to your home."],
            ["fa-pills", "Blister Packaging", "Free blister packaging to simplify your medication routine."],
            ["fa-vials", "Strep & Lab Testing", "Lab work request, strep throat testing, and results review services.", true],
            ["fa-notes-medical", "Medication Review", "Professional medication assessment for safety and effectiveness."],
            ["fa-smoking-ban", "Smoking Cessation", "Programs and support to help you quit smoking for good."],
            ["fa-vial", "Specialty Compounding", "Available as early as same day."],
            ["fa-heart", "Blood Pressure Monitoring", "Regular checks to help you stay on top of your heart health."],
            ["fa-diagnoses", "Diabetes Management", "Comprehensive support and monitoring for managing diabetes."],
          ].map((item, index) => (
            <div
              key={index}
              className={`service-card slide-up-delay-${(index % 4) + 1}`}
            >
              <i className={`fas ${item[0]}`}></i>
              <h3>{item[1]}</h3>
              <p>{item[2]}</p>

              {item[3] && (
                <Link
                  to="/book-appointment"
                  className="btn-secondary"
                  style={{ marginTop: "12px", display: "inline-block" }}
                >
                  Book Now
                </Link>
              )}
            </div>
          ))} */}

          {[
  ["fa-percent", "Senior Discount", "25% Senior Discount everyday to help reduce healthcare costs.", false, "will not go below the cost price.*"],
  ["fa-calendar-alt", "Open 7 Days", "Pharmacy and Travel Clinic.", false],
  ["fa-user-nurse", "Prescribing Pharmacist on Duty", "Prescribing pharmacist available all the time for expert guidance.", false],
  ["fa-syringe", "Injection & Vaccination", "Professional injection services and up-to-date vaccinations.", true],
  ["fa-plane", "Travel Consultation", "Before and after your trip.", true],
  ["fa-truck", "Free Prescription Delivery", "Fast, convenient medication delivery to your home.", false],
  ["fa-pills", "Blister Packaging", "Free blister packaging to simplify your medication routine.", false],
  ["fa-vials", "Strep & Lab Testing", "Lab work request, strep throat testing, and results review services.", true],
  ["fa-notes-medical", "Medication Review", "Professional medication assessment for safety and effectiveness.", false],
  ["fa-smoking-ban", "Smoking Cessation", "Programs and support to help you quit smoking for good.", false],
  ["fa-vial", "Specialty Compounding", "Available as early as same day.", false],
  ["fa-heart", "Blood Pressure Monitoring", "Regular checks to help you stay on top of your heart health.", false],
  ["fa-diagnoses", "Diabetes Management", "Comprehensive support and monitoring for managing diabetes.", false],
].map((item, index) => {
  const title = item[1];
  const target = serviceRoutes[title];

  return (
    <div
      key={index}
      className={`service-card slide-up-delay-${(index % 4) + 1}`}
      onClick={() => target && navigate(target)}
      style={{ cursor: "pointer" }}
    >
      <i className={`fas ${item[0]}`}></i>
      <h3>{title}</h3>
      <p>{item[2]}</p>
      <p>{item[4]}</p>

      {item[3] && (
        <Link
          to="/book-appointment"
          className="btn-secondary"
          style={{ marginTop: "12px", display: "inline-block" }}
          onClick={(e) => e.stopPropagation()} // prevent card click
        >
          Book Now
        </Link>
      )}
    </div>
  );
})}
        </div>
      </section>

      <Footer />
    </>
  );
}

export default ServicesPage;